export default class LiteratureOrderEvents {
  public static selectItem = 'select-item';
}
